module.exports = __webpack_public_path__ + "static/media/hero-2.928b379a.jpg";